export default __webpack_public_path__ + "cc0651982811b59fc176c76efd78d836.gif";